import { createContext } from 'react';

interface FormFieldContextValue {
  name: string;
}

export const FormFieldContext = createContext<FormFieldContextValue>({
  name: 'field_name',
});
